import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSWRConfig } from 'swr'
import { useAddLocaleParams } from '~/features/i18n/hooks/useAddLocaleParams'
import { useAxios } from '~/libs/axios'
import { DeleteUserResponse } from '~/types/api/withdrawal'
import { FormState, WithdrawalFormHandler, WithdrawalResponse } from './type'

export function useWithdrawalFormHandler(): WithdrawalFormHandler {
  const axios = useAxios()
  const { t } = useTranslation()
  const { cache } = useSWRConfig()
  const localeParams = useAddLocaleParams()
  const [formState, setFormState] = useState<FormState>({
    selectReason: [],
    freeTextReason: '',
  })
  const [withdrawalResponse, setWithdrawalResponse] = useState<WithdrawalResponse>({
    isLoading: false,
  })

  const handleChangeSelectedReason = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const reason = e.target.value
      setFormState((prev) => {
        const index = prev.selectReason.indexOf(reason)
        //チェック済みの場合
        if (index !== -1) {
          return { ...prev, selectReason: prev.selectReason.filter((v) => v !== reason) }
          //未チェックの場合
        } else {
          return { ...prev, selectReason: [...prev.selectReason, reason] }
        }
      })
    },
    [setFormState],
  )

  const handleChangeFreeTextReason = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFormState((prev) => ({ ...prev, freeTextReason: e.target.value }))
    },
    [setFormState],
  )

  const handleWithdrawalSubmit = useCallback(async () => {
    setWithdrawalResponse({ ...withdrawalResponse, isLoading: true })
    try {
      const res = await axios.delete<DeleteUserResponse>(`/v2/user`, {
        data: {
          other_reasons: formState.freeTextReason,
          withdrawal_reasons: formState.selectReason,
        },
      })
      cache.delete(`/v2/user/edit?${localeParams}`)
      setWithdrawalResponse({
        ...withdrawalResponse,
        deletedUserInfo: res.data,
        isLoading: false,
      })
    } catch (error) {
      setWithdrawalResponse({
        ...withdrawalResponse,
        isLoading: false,
        error: t('error_occurred'),
      })
    }
  }, [axios, formState, withdrawalResponse, cache, t, localeParams])

  return {
    formState,
    withdrawalResponse,
    handleWithdrawalSubmit,
    isValidated: formState.selectReason.length !== 0,
    handleChangeSelectedReason,
    handleChangeFreeTextReason,
  }
}
